import { SpinLoader } from 'app/components';
import * as React from 'react';
import { useEffect } from 'react';
import { useActionCreators } from 'app/area/favourite/hooks';
import { useQueryParams } from 'app/area/shared/navigation';

export function CreateFavouriteDraftRoute() {

  const { query } = useQueryParams();

  const report = query?.report ?
    parseInt(query.report, 10) :
    undefined;
    const {
      createSearchDefinition
    } = useActionCreators();
  useEffect(() => {
    const createDraft = async () => {
      createSearchDefinition(report);
    };
    createDraft();
  }, []);

  return <SpinLoader />;
}
